import _ from "lodash";
import {getCurrentUser} from "_helpers";
import {utilityActions} from "_actions";

export function getRandomPositiveDescription() {
    return _.sample(descriptionArray);
}

const feedbackType = {
    MISTAKE: 'MISTAKE',
    POSITIVE: 'POSITIVE',
};

export const feedbackOptions = [
    {id: "Typo in response_sent", name: "Typo in response sent"},
    {id: "Incorrect response", name: "Incorrect response"},
    {id: "Missed message", name: "Missed message"},
    {id: "Skipped when should have answered", name: "Skipped when should have answered"},
    {id: "Should have chosen no response", name: "Should have chosen no response"},
    {id: "Should have escalated", name: "Should have escalated"},
    {id: "Should have skipped", name: "Should have skipped"}
];

export const descriptionArray = [
    "Great work on this message!",
    "Well done on this message, keep it up!",
    "You did a good job on this message",
    "I really like how you handled this message",
    "Nice work on this message!",
    "Nice job on this message",
    "Good work on this message!",
    "Keep up the good work!",
    "Very nicely done!"
];

export function buildPositiveFeedbackPayload(message) {
    if(!message) return null;

    const {id} = getCurrentUser();
    const messageId = _.get(message, 'id');
    const agentId = _.get(message, 'agent.id');
    const rootUrl = utilityActions.getRootUrl();
    const description = getRandomPositiveDescription();
    const messageUrl = window.location.href.trim();

    const data = new FormData();
    data.append('agentId', agentId);
    data.append('reporterId', id);
    data.append('messageUrl', messageUrl);
    data.append('description', description);
    data.append('clientRootUrl', rootUrl);
    data.append('typeName', feedbackType.POSITIVE);
    data.append('messageId', messageId);

    return data;
}

export function buildConstructiveFeedbackPayload(message, description, selectedFeedbackType, fileInput = undefined) {
    if(!message || !description) return null;

    const {id} = getCurrentUser();
    const messageId = _.get(message, 'id');
    const agentId = _.get(message, 'agent.id');
    const rootUrl = utilityActions.getRootUrl();
    const messageUrl = window.location.href.trim();
    const selectedOption = _.get(selectedFeedbackType, 'id');

    const data = new FormData();
    data.append('agentId', agentId);
    data.append('reporterId', id);
    data.append('messageUrl', messageUrl);
    data.append('description', description);
    data.append('clientRootUrl', rootUrl);
    data.append('typeName', feedbackType.MISTAKE);
    data.append('messageId', messageId);
    data.append('feedBackOptions', selectedOption);
    if (fileInput) data.append('screenshot', fileInput)

    return data;
}